import React, { useMemo } from 'react';
import DLL from '@visma/formula/lib/dll';
import { useHistory, useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';

import { withPageBase } from '../../components/PageBase';
import { createLogEvent, saveUserInfoRequestID } from '../../data/user/userInfoRequests/actions';
import { userSelector } from '../../data/selector';
import { CustomConfirm } from './customConfirm';
import { IntlProvider, useIntl } from 'react-intl';

const { id: module_id } = module;

const EventStatus = { SUCCESS: 'SUCCESS', FAILURE: 'FAILURE' };

const UserInfoRequestForm = ({ saveUserInfoRequestID, createLogEvent }) => {
  const { id } = useParams();
  const history = useHistory();
  const user = useSelector(userSelector);
  const form = DLL.useForm(id);
  const { submit } = DLL.useMutations();
  const intl = useIntl();
  const locale = {
    'en': 'en-US',
    'fi': 'fi-FI',
    'sv': 'sv-SE',
  }[intl.locale];

  const autofillData = useMemo(() => {
    const { address, phone, email } = user.userInfo.data
    return {
      autofill_group_contactinfo: {
        autofill_address: address,
        autofill_phone: phone,
        autofill_email: email
      },
    };
  }, [user.userInfo.data])

  const handleOnPostSubmit = (formulaResponse) => {
    const { formObjectId } = formulaResponse?.attributes;

    const logEvent = ({
      requestTitle: form.title,
      status: EventStatus.SUCCESS
    })
    createLogEvent(logEvent)

    saveUserInfoRequestID(formObjectId);
    history.push('/userInfo');
  };

  const handleSubmitError = () => {
    const logEvent = ({
      requestTitle: form.title,
      status: EventStatus.FAILURE
    })
    createLogEvent(logEvent);
  }

  return (
        <IntlProvider
            {...intl}
            locale={locale}>
          <div className="not-aui">
          <DLL.Form
              id={id}
              formData={autofillData}
              confirmComponent={CustomConfirm}
              onSubmit={async (...args) => {
                try {
                  return await submit(...args);
                } catch (error) {
                  handleSubmitError();
                  throw error;
                }
              }}
              onPostSubmit={handleOnPostSubmit}/>
          </div>
        </IntlProvider>
  );
};


const mapStateToProps = () => {
  return {};
};

export default withPageBase(
  connect(mapStateToProps, { saveUserInfoRequestID, createLogEvent })(UserInfoRequestForm),
  {
    title: `${module_id}.title`
  }
);
